import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_38.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Head from "next/head";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter38.json";

export default function Chapter_38() {
  //     const corosalref = useRef()

  //     useEffect(()=>{
  //       if(corosalref.current)
  //       {
  //           corosalref.current.scrollIntoView({
  //               behavior: "smooth",
  //               block: "nearest",
  //               inline: "start"
  //           })
  //       }
  //       console.log("CurrentImageComponent",corosalref.current);
  //   },[corosalref.current])

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;


  return (
    <>
      <Head>
        <title>HAT REGIONS | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XXXIX"
        ></meta>
        <meta
          property="og:title"
          content="HAT REGIONS | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="An abstract representation of Hat Regions, featuring intricate cosmic patterns and mystical symbols. The image illustrates the enigmatic zones of divine and metaphysical significance, showcasing their influence on the cosmic and spiritual dimensions."></meta>
        <meta
          property="og:description"
          content="Discover the Central Doctrine of Hat Regions, exploring the enigmatic zones of cosmic and metaphysical significance. Delve into how these regions influence spiritual and physical dimensions, revealing their role in the grand tapestry of divine existence and consciousness."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=38"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="An abstract representation of Hat Regions, featuring intricate cosmic patterns and mystical symbols. The image illustrates the enigmatic zones of divine and metaphysical significance, showcasing their influence on the cosmic and spiritual dimensions."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=38"></meta>
        <meta name="twitter:title" content="HAT REGIONS | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Discover the Central Doctrine of Hat Regions, exploring the enigmatic zones of cosmic and metaphysical significance. Delve into how these regions influence spiritual and physical dimensions, revealing their role in the grand tapestry of divine existence and consciousness."></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=38" />

      </Head>


      <Common_html BlockData={BlockData} />
    </>
  );
}
